export default "__VITE_ASSET__CSPofPj5__"